<script lang="ts">
  import { page } from '$app/stores';
  import { session } from '$lib/stores';
</script>

<div class="px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
  <div class="max-w-max mx-auto">
    <main class="sm:flex">
      <p class="text-4xl font-extrabold text-primary-500 sm:text-5xl">{$page.status}</p>
      <div class="sm:ml-6">
        <div class="sm:border-l sm:border-gray-200 sm:pl-6">
          <h1 class="text-4xl font-extrabold text-primary-500 tracking-tight sm:text-5xl">
            {$page.status == 404 ? 'Página no encontrada' : 'Error'}
          </h1>
          <p class="mt-1 text-base text-gray-500">
            {$page.status == 404
              ? 'La página que estás buscando no existe.'
              : 'Ha ocurrido un error inesperado.'}
          </p>
          {#if $session?.role == 'admin' && $page.status == 500}
            <p class="text-red-500 text-center">
              <strong>Error: </strong>
              {$page.error?.message}
            </p>
          {/if}
        </div>
        <div class="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
          <a
            href="/"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            Ir al inicio
          </a>
          <a
            href="/contacto"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            Contactar con el soporte
          </a>
        </div>
      </div>
    </main>
  </div>
</div>
